import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'

import GeneralMixin from './mixins/general-mixin'
import axios from 'axios'

import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import vco from 'v-click-outside'
import VueRouter from 'vue-router'
import VueFeather from 'vue-feather'
import flatPickr from 'vue-flatpickr-component'
import * as VueGoogleMaps from 'vue2-google-maps'

import moment from 'moment'
//import VueQRCodeComponent from 'vue-qrcode-component'
import qrcode from 'vue-qrcode2';
import QRCodeVue3 from "qrcode-vue3";
import ContentItem from '@components/content-item'
import FieldItem from '@components/field-item'
import ChapterItem from '@components/chapter-item'
import SubChapterItem from '@components/subchapter-item'
import ToolItem from '@components/tool-item'
import Tool from '@components/tool'
import StoryItem from '@components/story-item'
import TestItem from '@components/test-item'
import Question from '@components/question'
import TestQuestion from '@components/test-question'
import Feedback from '@components/feedback'

import VueAgile from 'vue-agile'

import PageHeader from '@components/page-header'

import TrainingItem from '@components/training-item'
import VueSnip from 'vue-snip'
import VueLoadImage from 'vue-load-image'
import VSwatches from 'vue-swatches'

// Import the styles too, globally
import "vue-swatches/dist/vue-swatches.css"
import DrVueEcharts from 'dr-vue-echarts';
import i18n from "./i18n";

import VueImageLoader from '@kevindesousa/vue-image-loader'

import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
import VueConfetti from 'vue-confetti'

Vue.use(VueConfetti)

Vue.use(VueImageLoader)


Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCxRX2sEktrUI21S-hRwjF7I0Q6-I-aeJU',
    libraries: 'places', 
  },
  installComponents: true
})






//production
axios.defaults.baseURL='https://gebi-server.addisapps.com'

//development
//axios.defaults.baseURL='http://localhost:3000'









Vue.mixin(GeneralMixin)

Vue.use(VueFeather)
Vue.use(flatPickr)

Vue.use(VueRouter)
Vue.use(vco)
Vue.use(VueSnip)
Vue.use(VuePlyr)


// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)

Vue.use(qrcode);
Vue.use(DrVueEcharts)

Vue.use(VueAgile)


Vue.component('apexchart', VueApexCharts)
//Vue.component('qr-code', VueQRCodeComponent)
//Vue.component('QRCodeVue3',QRCodeVue3)
Vue.component('ContentItem', ContentItem)
Vue.component('FieldItem', FieldItem)
Vue.component('ChapterItem', ChapterItem)
Vue.component('SubChapterItem', SubChapterItem)
Vue.component('ToolItem', ToolItem)
Vue.component('Tool', Tool)
Vue.component('StoryItem', StoryItem)
Vue.component('TestItem', TestItem)
Vue.component('Question', Question)
Vue.component('TestQuestion', TestQuestion)
Vue.component('Feedback', Feedback)
Vue.component('PageHeader', PageHeader)
Vue.component('TrainingItem', TrainingItem)
Vue.component('VueLoadImage', VueLoadImage)
Vue.component('v-swatches', VSwatches)
Vue.component('VueperSlides', VueperSlides)
Vue.component('VueperSlide', VueperSlide)

Vue.prototype.moment = moment

// Vue.mixin({
//   data: function() {
//     return {
//       baseUrl:'http://localhost:3000'
//     }
//   }
// })

// Uncomment this if you are having api served through other url or do not want to use fake backend
// Vue.prototype.$http = require('axios')
// Vue.prototype.$http.defaults.baseURL  = 'http://mock-api.addisapps.com/'

const app = new Vue({
  el: "#app",
    data: {
        onLine: navigator.onLine,
        showBackOnline: false
    },
    methods: {
        updateOnlineStatus(e) {
            const {
                type
            } = e;
            this.onLine = type === 'online';
        }
    },
    watch: {
        onLine(v) {
            if (v) {
              console.log('Back online')
                this.showBackOnline = true;
                setTimeout(() => {
                    this.showBackOnline = false;
                }, 1000);
            }
            else{
              console.log('offline')
            }
        }
    },
    mounted() {
        //axios.defaults.baseURL=this.serverUrl
        window.addEventListener('online', this.updateOnlineStatus);
        window.addEventListener('offline', this.updateOnlineStatus);
    },
    beforeDestroy() {
        window.removeEventListener('online', this.updateOnlineStatus);
        window.removeEventListener('offline', this.updateOnlineStatus);
    },
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}




